import React from "react";
import { MainContainer, InfoMainContainer, InfoContainer, ImageContainer, ImageStyled, LargeButton, MainMessage, Message1, Message2 } from "./styles";
import ErrorImage from "../../assets/hub-reserve-white.png";
import { ROUTES } from '../../routes/constants';
import { useNavigate } from 'react-router-dom';
import { postActivateAccount } from "../../services/user/postActions";
import { useLocation } from 'react-router-dom';
import { useToasts } from "react-toast-notifications";

const ActivateAccount = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email');
    const token = queryParams.get('token');
    const navigate = useNavigate();
    const { addToast } = useToasts();

    React.useEffect(() => {
        if (!email || !token) {
            navigate(`${ROUTES.ERROR}`)
        }
    }, [])

    const activateAccout = async () => {
        await postActivateAccount(email!, token!)
            .then((res: any) => {
                if (res && res.data && res.status < 300) {
                    addToast("Cuenta verificada", {
                        appearance: "success",
                        autoDismiss: true,
                    });
                    navigate(`${ROUTES.LOGIN}`);
                } else {
                    addToast("Ocurrió un error al validar su cuenta", {
                        appearance: "error",
                        autoDismiss: true,
                    });
                }
            })
            .catch((err: any) => {
                console.error(err);
            });
    }

    return (
        <>
            <MainContainer>
                <InfoMainContainer>
                    <InfoContainer>
                        <MainMessage>Bienvenido</MainMessage>
                        <Message1>Favor de verificar su correo</Message1>
                        <Message2>Dar click en el botón de abajo</Message2>
                    </InfoContainer>

                    <LargeButton onClick={activateAccout}
                    >Activar cuenta</LargeButton>
                </InfoMainContainer>

                <ImageContainer>
                    <ImageStyled src={ErrorImage} alt="Activate icon"></ImageStyled>
                </ImageContainer>
            </MainContainer>
        </>
    );
}

export default ActivateAccount;